import React, { useEffect, useState } from "react";
import styles from "./ChannelHandling.module.css";
import proxy from "proxy"; // Replace with actual proxy, e.g. "http://localhost:5000"
import { useNavigate } from "react-router-dom";

const ChannelsHandling = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  useEffect(()=>{
    const email=localStorage.getItem("email")
    if (  email!== "nandan@dicot.tech"){
      navigate("/")
    }
  },[])

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredCustomers = customers.filter((customer) =>
    customer.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleChannelChange = (index, value) => {
    const updated = [...customers];
    updated[index].allowedChannels = value;
    setCustomers(updated);
  };

  const handleUserChange = (index, value) => {
    const updated = [...customers];
    updated[index].allowedUsers = value || ""; // allow blank while editing
    setCustomers(updated);
  };


  const handleUserBlur = (index) => {
    const updated = [...customers];
    const val = parseInt(updated[index].allowedUsers, 10);

    if (isNaN(val) || val < 5) {
      updated[index].allowedUsers = 5;
    }

    setCustomers(updated);
  };


  const handleSave = async (index) => {
    const customer = customers[index];
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${proxy}/customer/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          allowedChannels: customer.allowedChannels,
          allowedUsers: customer.allowedUsers,
          email: customer.email,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update customer.");
      }

      alert(`Changes saved for ${customer.name}`);
    } catch (error) {
      console.error("Error saving customer changes:", error);
      alert("Failed to save changes.");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");


    const fetchUsers = async () => {
      try {
        const response = await fetch(`${proxy}/customer/getusers`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseBody = await response.json();

        // Ensure allowedUsers defaults to 5 if undefined, null, or < 5
        const normalizedCustomers = responseBody.map((customer) => ({
          ...customer,
          allowedUsers:
            typeof customer.allowedUsers === "number" && customer.allowedUsers >= 5
              ? customer.allowedUsers
              : 5,
        }));

        setCustomers(normalizedCustomers);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search customer by name..."
          value={searchTerm}
          onChange={handleSearchChange}
          className={styles.searchBar}
        />
      </div>

      <div className={styles.cardsContainer}>
        {filteredCustomers.length > 0 ? (
          filteredCustomers.map((customer, index) => (
            <div key={customer._id || index} className={styles.card}>
              <div className={styles.info}>
                <p><strong>Name:</strong> {customer.name}</p>
                <p><strong>Email:</strong> {customer.email}</p>
                <p><strong>Phone No.:</strong> {customer.phone}</p>

                <div>
                  <strong>Allowed Channels:</strong>
                  <input
                    type="number"
                    min="0"
                    value={customer.allowedChannels}
                    onChange={(e) =>
                      handleChannelChange(index, parseInt(e.target.value))
                    }
                    className={styles.channelInput}
                  />
                </div>

                <div>
                  <strong>Users Allowed:</strong>
                  <input
                    type="number"
                    value={customer.allowedUsers}
                    onChange={(e) =>
                      handleUserChange(index, parseInt(e.target.value || "0", 10))
                    }
                    onBlur={() => handleUserBlur(index)}
                    className={styles.channelInput}
                  />
                </div>

                <button
                  onClick={() => handleSave(index)}
                  className={styles.saveButton}
                >
                  Save
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>No customer found.</p>
        )}
      </div>
    </div>
  );
};

export default ChannelsHandling;
